// Libraries
import { TypeOf, z } from 'zod';

const FuelTypeSchema = z.object({
  id: z.number(),
  name: z.string(),
  price: z.number(),
  minPrice: z.number(),
  maxPrice: z.number(),
  co2ConversionFactor: z.number(),
});

const ComponentAnalysisSchema = z.object({
  foulingContributionPercentage: z.number(),
  speedContributionPercentage: z.number(),
  weatherContributionPercentage: z.number(),
});

const UnderwaterCleaningSchema = z.object({
  underWaterCleaningCo2Change: z.number(),
  underWaterCleaningFocChange: z.number(),
  underWaterCleaningPercentageChange: z.number(),
});

export const VesselSimulatedSchema = z.object({
  imo: z.number(),
  year: z.number(),
  yearToDateFoc: z.number(),
  yearToDateCo2: z.number(),
  yearToDateDistanceSailed: z.number(),
  yearToDateAverageSpeed: z.number(),
  yearToDateCiiAttained: z.number(),
  yearToDateCiiRating: z.string(),
  forecastedFoc: z.number(),
  forecastedCo2: z.number(),
  forecastedDistanceSailed: z.number(),
  forecastedAverageSpeed: z.number(),
  forecastedRemainingDaysOfSailing: z.number(),
  forecastedAverageBeaufort: z.number(),
  forecastedCiiAttained: z.number(),
  forecastedCiiRating: z.string(),
  requiredCiiScore: z.number(),
  name: z.string(),
  clientId: z.number(),
  vesselTypeId: z.number(),
  yearBuilt: z.number(),
  shipyard: z.string(),
  maxCapacity: z.number(),
  maxSpeed: z.number(),
  minSpeed: z.number(),
  displacementAtBallast: z.number(),
  displacementAtLaden: z.number(),
});

const DataSchema = z.object({
  fuelTypes: z.array(FuelTypeSchema),
  operationalYear: z.number(),
  componentAnalysis: ComponentAnalysisSchema,
  underwaterCleaning: UnderwaterCleaningSchema,
  vessel: VesselSimulatedSchema,
});

export const VesselSimulatorSchema = z.object({
  status: z.number(),
  data: DataSchema,
});

export type VesselSimulatorData = TypeOf<typeof VesselSimulatorSchema>;
